<script setup>
import { computed, ref } from "vue";
import iphoneModels from "../utils/iphoneModels.js";

const props = defineProps({
  open: { type: Boolean, default: false },
  cameras: { type: Array, default: () => [] }
});

const emit = defineEmits(["select", "close"]);

const selectedItem = ref(null);

const items = computed(() => {
  let list;
  if (props.cameras.length > 3) {
    list = iphoneModels.proModels;
  } else if (props.cameras.length > 1 && props.cameras.length <= 3) {
    list = [...iphoneModels.nonProMultiCamera, { model: "Other" }];
  } else {
    list = [...iphoneModels.singleCamera, { model: "Other" }];
  }
  return list;
});

const close = (skip) => {
  emit("close", skip);
};
const selectItem = (item) => {
  selectedItem.value = item;
};

const confirmSelection = () => {
  if (!selectedItem.value) return;
  if (selectedItem.value.model === "Other") {
    window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
  } else {
    if (window.localStorage.getItem("iphoneModel") !== selectedItem.value.model) {
      window.localStorage.setItem("iphoneModel", selectedItem.value.model);
    }
    emit("select");
  }
  close();
};
</script>

<template>
<transition name="slide-up">
  <div v-if="open" class="models-picker-wrapper" @click.self="close">
    <div class="sheet" role="dialog" aria-modal="true">
      <div class="header">
        <button class="close-btn" aria-label="Close" @click="close(true)">
          <img src="../assets/close.svg" width="24" height="24" alt="" />
        </button>
      </div>
      <div class="title">
        {{ $t("iphone_models.title") }}
      </div>
      <div class="description">
        {{ $t("iphone_models.description") }}
      </div>
      <ul class="list">
        <li v-for="item in items" :key="item.model" :class="['row', { selected: selectedItem && selectedItem.model === item.model }]" @click="selectItem(item)">
          <div class="model-box">
            <div class="model">
              {{ item.model }}
            </div>
            <div v-if="selectedItem && selectedItem.model === item.model" class="check">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
                <g clip-path="url(#clip0_1012_1937)">
                  <path d="M9.50016 16.1701L5.33016 12.0001L3.91016 13.4101L9.50016 19.0001L21.5002 7.00009L20.0902 5.59009L9.50016 16.1701Z" fill="#15BBF0" />
                </g>
                <defs>
                  <clipPath id="clip0_1012_1937">
                    <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </li>
      </ul>
      <button class="continue-btn" :disabled="!selectedItem" @click="confirmSelection">
        {{ $t("iphone_models.continue") }}
      </button>
    </div>
  </div>
</transition>
</template>

<style scoped>
.models-picker-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 99999;
}
.sheet {
  background: #fff;
  box-shadow: 0 -1px 10px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 18px;
  max-height: 95dvh;
}
.header {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}
.title {
  font-size: 18px;
  font-weight: 700;
  color: #222222;
  text-align: center;
  margin-top: 15px;
}
.close-btn {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  position: fixed;
}
.list {
  padding: 0;
  margin: 0;
  text-align: center;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.row {
  cursor: pointer;
  color: var(--secondary);
  text-align: center;
  padding: 6px 10px;
}
.row.selected {
  background: color-mix(in srgb, var(--secondary) 20%, transparent);
}

.row > .model-box {
  position: relative;
  text-align: center;
  width: 100%;
}
.model {
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  width: 100%;
}
.row.selected .model {
  font-weight: 700 !important;
}
.check {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
}
.check svg path {
  fill: var(--secondary);
}
.description {
  font-size: 14px;
}
.continue-btn {
  margin: auto;
  display: block;
  padding: 10px;
  background: #000000;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 700;
}
.continue-btn:disabled {
  background: #999;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition:
    transform 220ms ease,
    opacity 220ms ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(16px);
  opacity: 0;
}
</style>
